<template>
   <v-container fluid grid-list-lg class="py-3 px-3">
    <DiskList v-if="showList"/>
   </v-container>
</template>

<script>
import DiskList from './DiskList'

export default {
  name: 'Dashboard',
  components: {
    DiskList,
  },
  computed: {
    blockHeight(){
      return (this.$vuetify.breakpoint.height - 48 - 40 - 30 )+'px'
    },
  },
  data() {
    return {
      showList: false
    }
  },
  created () {
    if (this.$route.query && this.$route.query.code && this.$route.query.id) {
      const googleToken = {
        id: this.$route.query.id,
        code: this.$route.query.code
      }
      this.$store.dispatch('disk/googleAuth', googleToken).then( response => {
        this.showList = !this.showList
      })
      .catch(error => {
        this.$dmsErrorNoty(error.message)
        this.showList = !this.showList
      })
    } else {
      this.showList = !this.showList
    }
  },
};
</script>

<style lang="scss" scoped>
.disk-title {
  font-weight: 700;
  font-size: 24px;
}

.circle {
    width: 13px;
    height: 13px;
    background-color: trasparent;
    border-radius: 8px;

    &.auth {
      background: #1fef1f;
    }

    &.noAuth {
      background: red;
    }
}
</style>



// WEBPACK FOOTER //
// src/apps/disk/components/Dashboard/Dashboard.vue